<template>
    <form
        ref="submitPaymentForm"
        method="POST"
        charset="UTF-8"
        action="https://ssl.ditonlinebetalingssystem.dk/integration/ewindow/Default.aspx"
    >
        <input
            v-for="input in inputs"
            :key="input.name"
            type="hidden"
            :name="input.name"
            :value="input.value"
        />
    </form>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { initEpayPayment } from "../../api/modules/confirm";

export default {
    data() {
        return {
            epayOrderId: null
        };
    },
    computed: {
        epaylang() {
            switch (this.$i18n.locale) {
                case "en":
                    return 2;
                case "de":
                    return 7;
                default:
                    return 1; // da
            }
        },
        inputs() {
            const inputs = [
                {
                    name: "accepturl",
                    value:
                        window.location.origin +
                        `/payment/?provider=Epay&reference=${encodeURIComponent(
                            this.orderId
                        )}`
                },
                {
                    name: "currency",
                    value: "208" // DKK
                },
                {
                    name: "merchantnumber",
                    value: this.merchantId
                },
                {
                    name: "orderid",
                    value: this.epayOrderId
                },
                {
                    name: "language",
                    value: this.epaylang
                },
                {
                    name: "windowstate",
                    value: 3
                },
                {
                    name: "ownreceipt",
                    value: 1
                },
                {
                    name: "amount",
                    value: this.orderPriceOre
                }
            ];

            return inputs;
        },
        ...mapGetters({
            orderId: "order/getOrderId",
            orderPriceOre: "order/getPriceOre",
            merchantId: "system/getEpayMerchantId"
        })
    },
    watch: {
        epayOrderId: function(value) {
            if (value) {
                Vue.nextTick().then(() => {
                    // DOM updated
                    this.$refs.submitPaymentForm.submit();
                });
            }
        }
    },
    mounted() {
        this.$emit("loading", "Redirecting to Epay");
        return initEpayPayment(this.orderId).then(response => {
            if (!response.ok) {
                throw new Error(JSON.stringify(response));
            }

            this.epayOrderId = response.responseBody.epayPaymentId;
        });
    }
};
</script>
